<div [ngStyle]="dimensions" class="loader"></div>
